(ns ycweb.app.website.myaccount.reviews.thankyou
  (:require
   [rum.core :as rum]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.app.website.myaccount.reviews.common :as reviews-common]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc thank-you < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        review-item (cmn/curact action-atom [:review])
        {:item-line/keys [product]} review-item
        {:product/keys [link]} product]
    [:div.dashboard.dashboard--underline
     (headings/heading "Thank you. We've received your review." {:type :h2 :size :medium :icon :message})
     [:div.u-max-width-720
      [:p.yc-paragraph.yc-paragraph--flush
       "Thank you for your review of the "
       [:a.text-link.text-link--muted {:href link} (:ent/display-name product)]
       ". We'll evaluate it within 1-3 working days and publish it if it meets our "
       [:a.text-link.text-link--muted.js-mfp-open-url
        {:href "/help.htm?action=article&id=157"
         :target_url "/help.htm?action=article&id=157&overrideincludes=blank"
         :data-title "Product Review Terms & Conditions"
         :data-content-wrapper-class "yc-simple-text"}
        "review guidelines"]
       ". If you like, you can "
       [:a.text-link.text-link--muted
        (urlstate/href-props app-atom "myaccount" "reviews")
        "track the status of your review"]
       "."]
      [:br]]
     [:div.dashobard
      [:div.u-max-width-890
       (reviews-common/review-block review-item)]
      [:div.dashboard-footer.button-group
       #_(buttons/button-web "Return to product page"
           {:href link
            :class (u/bem :button [:primary :default :raised])})]]
     (toaster/loading-overlay app-atom :web.myaccount/reviewsthankyou)]))

(defmethod flow/render-screen :web.myaccount/reviewsthankyou [app-atom _]
  (awm.common/screen-wrapper app-atom
    (thank-you app-atom)))

(defmethod t/transition-open :web.myaccount/reviewsthankyou [app-atom _ params]
  (toaster/open-overlay app-atom :web.myaccount/reviewsthankyou)
  (comms/ajax-get :web.myaccount/reviewthankyou (select-keys params [:uuid])))

(defmethod comms/receive :web.myaccount/reviewthankyou [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc
    :review (:review e))
  (toaster/close-overlay app-atom :web.myaccount/reviewsthankyou))